import { render, staticRenderFns } from "./RecommendationsSlide.vue?vue&type=template&id=0514714a&scoped=true&"
import script from "./RecommendationsSlide.vue?vue&type=script&lang=js&"
export * from "./RecommendationsSlide.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationsSlide.vue?vue&type=style&index=0&id=0514714a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0514714a",
  null
  
)

export default component.exports